"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var PromptTypes_1 = require("Prompt/PromptTypes");
var event_tracker_types_1 = require("@qwilr/event-tracker-types");
var CardIdToTelemetryActionCardType = new Map([
    [
        PromptTypes_1.PromptId.PagesDashboardOnboardingBanner,
        (_a = {},
            _a[UseHistoryTypes_1.PagesOnboardingBannerAction.EditorExperience] = event_tracker_types_1.ActionCardType.Editor,
            _a[UseHistoryTypes_1.PagesOnboardingBannerAction.BrandSetup] = event_tracker_types_1.ActionCardType.BrandSetup,
            _a[UseHistoryTypes_1.PagesOnboardingBannerAction.DocConversion] = event_tracker_types_1.ActionCardType.DocConversion,
            _a[UseHistoryTypes_1.PagesOnboardingBannerAction.GetHelp] = event_tracker_types_1.ActionCardType.Support,
            _a[UseHistoryTypes_1.PagesOnboardingBannerAction.CreateFromTemplate] = event_tracker_types_1.ActionCardType.CreateFromTemplate,
            _a),
    ],
]);
var PromptIdToTelemetryDashboardType = new Map([
    [PromptTypes_1.PromptId.PagesDashboardOnboardingBanner, event_tracker_types_1.DashboardType.Pages],
]);
var getTelemetryActionCardType = function (promptId, cardId) {
    if (CardIdToTelemetryActionCardType.has(promptId)) {
        var mappingObj = CardIdToTelemetryActionCardType.get(promptId);
        if (mappingObj === null || mappingObj === void 0 ? void 0 : mappingObj.hasOwnProperty(cardId)) {
            return mappingObj[cardId];
        }
    }
    throw new Error("Couldn't get telemetry action card type for promptId ".concat(promptId, " and card ").concat(cardId));
};
var getTelemetryDashboardType = function (promptId) {
    var _a;
    if (PromptIdToTelemetryDashboardType.has(promptId)) {
        return (_a = PromptIdToTelemetryDashboardType.get(promptId)) !== null && _a !== void 0 ? _a : event_tracker_types_1.DashboardType.Pages;
    }
    throw new Error("Couldn't get telemetry dashboard type for promptId ".concat(promptId));
};
var OnboardingBannerTelemetry = (function () {
    function OnboardingBannerTelemetry(serverTelemetry) {
        this.serverTelemetry = serverTelemetry;
    }
    OnboardingBannerTelemetry.prototype.cardClicked = function (promptId, cardId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.serverTelemetry.sendDashboardBannerCardPressedTelemetry({
                            eventProperties: {
                                dashboardType: getTelemetryDashboardType(promptId),
                                actionCardType: getTelemetryActionCardType(promptId, cardId),
                            },
                            eventOrigin: event_tracker_types_1.EventOrigin.QwilrDashboard,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    OnboardingBannerTelemetry.prototype.bannerDismissed = function (promptId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.serverTelemetry.sendDashboardBannerDismissedTelemetry({
                            eventProperties: {
                                dashboardType: getTelemetryDashboardType(promptId),
                            },
                            eventOrigin: event_tracker_types_1.EventOrigin.QwilrDashboard,
                        })];
                    case 1:
                        _a.sent();
                        return [2];
                }
            });
        });
    };
    return OnboardingBannerTelemetry;
}());
exports.default = OnboardingBannerTelemetry;
